import { formatCurrency as formatCurrencyShared, formatDate as formatDateShared } from '../../../utils/formatUtils';

/**
 * Utilidades para formatear datos en el módulo de movimientos bancarios
 */

export const formatCurrency = (amount) => formatCurrencyShared(amount, 2);

export const formatDate = (date) =>
  formatDateShared(date, { options: { day: '2-digit', month: '2-digit', year: 'numeric' } });

/**
 * Formatea el nombre del banco desde el enum
 * @param {string} bankName - Nombre del banco en formato enum
 * @returns {string} Nombre del banco formateado
 */
export const formatBankName = (bankName) => {
  if (!bankName) return '';

  const bankNames = {
    BANCO_GALICIA: 'GALICIA',
    BANCO_NACION: 'NACION',
    BANCO_PROVINCIA_BUENOS_AIRES: 'PROVINCIA BA',
    BANCO_ICBC: 'ICBC',
    CITIBANK: 'CITIBANK',
    BANCO_BBVA: 'BBVA',
    BANCO_PROVINCIA_CORDOBA: 'PROVINCIA CBA',
    BANCO_SUPERVIELLE: 'SUPERVIELLE',
    BANCO_CIUDAD: 'CIUDAD',
    BANCO_PATAGONIA: 'PATAGONIA',
    BANCO_HIPOTECARIO: 'HIPOTECARIO',
    BANCO_SAN_JUAN: 'SAN JUAN',
    BANCO_MUNICIPAL_ROSARIO: 'MUNICIPAL ROSARIO',
    BANCO_SANTANDER: 'SANTANDER',
    BANCO_CHUBUT: 'CHUBUT',
    BANCO_MACRO: 'MACRO',
    BANCO_CREDICOOP: 'CREDICOOP',
    HSBC_ARGENTINA: 'HSBC',
    BANCO_FRANCES: 'FRANCES',
    BANCO_COMAFI: 'COMAFI',
    BANCO_ITAU: 'ITAU',
    BANCO_INDUSTRIAL: 'INDUSTRIAL',
    BANCO_PIANO: 'PIANO',
    BANCO_VOII: 'VOII',
    BRUBANK: 'BRUBANK',
    BANCO_DEL_SOL: 'DEL SOL',
    BANCO_MASVENTAS: 'MASVENTAS',
    BANCO_ROELA: 'ROELA',
  };

  return bankNames[bankName] || bankName;
};

/**
 * Formatea el tipo de cuenta desde el enum
 * @param {string} accountType - Tipo de cuenta en formato enum
 * @returns {string} Tipo de cuenta formateado
 */
export const formatAccountType = (accountType) => {
  if (!accountType) return '';

  const accountTypes = {
    CHECKING_ACCOUNT: 'CTA-CTE',
    SAVINGS_ACCOUNT: 'CAJA AHORRO',
  };

  return accountTypes[accountType] || accountType;
};
